export default __webpack_public_path__ + "static/media/Service-1.80a83982.jpg";